import audioThumbnail from '@/resources/img/music-thumbnail.png';
import { AudioPlayerProps } from '@/types';

export const AudioPlayer = ({ audioUrl }: AudioPlayerProps) => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <img src={audioThumbnail} />
      <audio controls src={audioUrl} className='mt-2' />
    </div>
  );
};
